import React from "react";
import {
  FallbackHeaderBackground,
  FallbackHeaderLogo
} from "./FallbackHeader.styled";

const FallbackHeader = () => {
  return (
    <FallbackHeaderBackground>
      <FallbackHeaderLogo src="https://resources.ebsco.zone/images/EbscoLogo.svg" />
    </FallbackHeaderBackground>
  );
};

export default FallbackHeader;
